import { dfciVectorTileConfigs } from "./dfci/VectorTile";
export const vectorTileRegistry = {
  ...dfciVectorTileConfigs,
};
